/* hashedHotCard/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
    Salt: t.string,
    FullURL: t.string,
    DeltaURL: t.string
  }),
  t.partial({}),
]);

const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
  updatedAt: tOptional(t.string),
  createdAt: tOptional(t.string),
});
export type Data = t.TypeOf<typeof DataCodec>;

export const HashedHotCardCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "HashedHotCardCodec"
);

export const HotCardCodec = t.intersection([
  t.type({
  }),
  t.partial({
    Name: t.string,
    Salt: t.string,
    FullURL: t.string,
    DeltaURL: t.string,
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type HashedHotCard = t.TypeOf<typeof HashedHotCardCodec>;

export enum HashedHotCardActionTypes {
  FETCH = "@@hashedHotCard/FETCH",
  FETCH_SUCCESS = "@@hashedHotCard/FETCH_SUCCESS",
  FETCH_ERROR = "@@hashedHotCard/FETCH_ERROR",
  SAVE_REQUEST = "@@hashedHotCard/SAVE_REQUEST",
  SAVE_SUCCESS = "@@hashedHotCard/SAVE_SUCCESS",
  SAVE_ERROR = "@@hashedHotCard/SAVE_ERROR",
  DELETE_REQUEST = "@@hashedHotCard/DELETE_REQUEST",
  DELETE_SUCCESS = "@@hashedHotCard/DELETE_SUCCESS",
  DELETE_ERROR = "@@hashedHotCard/DELETE_ERROR",
}

export interface HashedHotCardState {
  readonly loading: boolean;
  readonly data: Data[];
  readonly errors?: string;
}
